export const dialogboxMixin = {
  methods: {
    async msgbox (obj) {
      try {
        return await this.$msgbox({
          title: obj.title,
          message: obj.content,
          cancelButtonText: obj.cancelAction,
          confirmButtonText: obj.confirmAction,
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          showClose: false,
          customClass: 'dialog__box dialog--animate',
          cancelButtonClass: 'dialog__actions--btn dialog__actions--underlined',
          confirmButtonClass: 'dialog__actions--btn'
        })
      } catch (err) { return err }
    }
  }
}
